<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="desktop">
    <HeaderDesktop :toggleProfileMode="toggleProfileMode" />
  </div>
  <div class="mobile">
    <HeaderMobile :toggleProfileMode="toggleProfileMode" />
  </div>
</template>

<script>
import HeaderDesktop from "@/components/HeaderDesktop.vue";
import HeaderMobile from "@/components/HeaderMobile.vue";

export default {
  props: {
    toggleProfileMode: Function,
  },
  components: {
    HeaderDesktop,
    HeaderMobile,
  },
};
</script>
<style lang="scss" scoped>
.mobile {
  display: none;
}

@media screen and (max-width: 768px) {
  .mobile {
    display: flex;
  }

  .desktop {
    display: none;
  }
}
</style>
